import { yupResolver } from '@hookform/resolvers/yup';
import React, { memo, useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useForm } from 'react-hook-form';

import Loader from "react-js-loader";
import { ToastContainer, toast } from 'react-toastify';
import * as Yup from 'yup';
import { getEndpointUrl } from "../../Utils/Common";

const CreateUser = ({ onCallback, show, close }) => {

    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [userLogin, setUserLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    const [accesToken, setAccessToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    useEffect(() => {

    }, [isLoading]);

    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Field harus diisi'),
        username: Yup.string().required('Field harus diisi'),
        phone: Yup.string().required('Field harus diisi'),
        email: Yup.string().email(),
        role: Yup.string().required('Field harus diisi'),
        status: Yup.string().required('Field harus diisi'),
        password: Yup.string().required('Field harus diisi'),
        confirmPassword: Yup.string().required('Field harus diisi').oneOf([Yup.ref('password'), null], 'Konfirmasi password tidak sama!')
    });

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm({
        mode: "onChange",
        resolver: yupResolver(validationSchema)
    });

    const onSubmit = data => {
        setLoading(true);

        let formData = new FormData();    //formdata object

        formData.append('name', data.name);
        formData.append('username', data.username);
        formData.append('email', data.email);
        formData.append('phone', data.phone);
        formData.append('role', data.role);
        formData.append('status', data.status);
        formData.append('password', data.password);
        formData.append('user_id', userLogin.id);

        fetch(getEndpointUrl() + '/users', {
            method: "POST",
            body: formData,
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            setLoading(false);

            if (json.status === 'ok') {

                toast.success("Yay, Data pengguna berhasil diinput.", {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                });

                close();

                onCallback(json.results.data);

            } else {
                toast.error(json.message, {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true
                });
            }
        }).catch(error => {
            setLoading(false);
        });
    };
    return (
        <>
            <ToastContainer position="top-end" className="p-3"></ToastContainer>
            <Modal show={show} size="lg" onHide={close} backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>{isLoading ? "Menyimpan data..." : "Tambahkan Pengguna Sistem"}</Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    {isLoading ?
                        <Modal.Body>
                            <div className="d-flex justify-content-center mt-5 mb-5">
                                <Loader type="bubble-scale" bgColor={"#42A5F5"} size={100} />
                            </div>
                        </Modal.Body>
                        :
                        <>
                            <Modal.Body>
                                <Row>
                                    <Col md={6} sm={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Nama pengguna</Form.Label>
                                            <Form.Control type="text" {...register("name")} isInvalid={errors.name ? true : false} autoComplete="off" />
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Username</Form.Label>
                                            <Form.Control type="text" {...register("username")} isInvalid={errors.username ? true : false} autoComplete="off" />
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>No Handphone</Form.Label>
                                            <Form.Control type="text" {...register("phone")} isInvalid={errors.phone ? true : false} autoComplete="off" />
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Alamat E-mail</Form.Label>
                                            <Form.Control type="text" {...register("email")} isInvalid={errors.email ? true : false} autoComplete="off" />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6} sm={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Role Akses</Form.Label>
                                            <Form.Select {...register("role")} isInvalid={errors.role ? true : false}>
                                                <option value="">- Pilih Akses -</option>
                                                <option value="admin">Administrator</option>
                                                <option value="inspector">Petugas Inspektor</option>
                                            </Form.Select>
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Password login</Form.Label>
                                            <Form.Control type="password" {...register("password")} isInvalid={errors.password ? true : false} autoComplete="off" />
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Konfirmasi password login</Form.Label>
                                            <Form.Control type="password" {...register("confirmPassword")} isInvalid={errors.confirmPassword ? true : false} autoComplete="off" />
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Status</Form.Label>
                                            <Form.Select {...register("status")} isInvalid={errors.status ? true : false}>
                                                <option value="">- Pilih Status -</option>
                                                <option value="active">Aktif</option>
                                                <option value="deactive">Tidak Aktif</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={close}> Batal </Button>
                                <Button variant="success" type="submit">Buat Pengguna Baru</Button>
                            </Modal.Footer>
                        </>
                    }
                </Form>
            </Modal>
        </>
    );
}

export default memo(CreateUser);
